import * as React from "react";

import SelectField, {OptionValue} from "../../components/SelectField";
import {DerivateUtils} from "../../components/Table/components/derivate/DerivateUtils";
import ColumnFactory from "../../services/ColumnFactory";
import {CnrDto, ModeltypeBasicDto, ModelyearDto, TypefamilyDto} from "../../services/Client";

interface ITechnicalDataHeaderProps {
    t: reactI18Next.TranslationFunction;

    selectedCnr?: CnrDto;
    userCnrs: CnrDto[];
    handleCnrChange: (dto?: CnrDto) => void;
    userLanguage: string;

    selectedModelyear?: ModelyearDto;
    userModelyears: ModelyearDto[];
    handleModelyearChange: (dto?: ModelyearDto) => void;

    selectedTypefamily?: TypefamilyDto;
    userTypefamilies: TypefamilyDto[];
    handleTypefamilyChange: (dto?: TypefamilyDto) => void;

    selectedDerivate?: ModeltypeBasicDto;
    derivates: ModeltypeBasicDto[];
    handleDerivateChange: (dto?: ModeltypeBasicDto) => void;
}

export const TechnicalDataHeader = (props: ITechnicalDataHeaderProps) => {

    /**
     * Return custom placeholder based on user view access rights
     *
     * @param hasRights
     *      the data source is not empty
     * @param placeholder
     *      field identifier
     */
    function createPlaceholderRenderer(hasRights: boolean, placeholder: string): string {
        return hasRights
            ? props.t(placeholder)
            : `${props.t("MISSING_ACCESS_RIGHTS")} (${props.t(placeholder)})`;
    }

    return (
        <div className={'technical-data-select-field-control'}>
            <SelectField
                key={'cnr-drp'}
                placeholder={createPlaceholderRenderer(props.userCnrs.length > 0, "CNR")}
                clearable={true}
                searchable={true}
                disabled={props.userCnrs.length === 0}
                value={props.selectedCnr}
                dataSource={props.userCnrs}
                rendererKey={(cnr: CnrDto): string => props.t(`GLOBAL:${cnr.cnr}`)}
                onChange={props.handleCnrChange}
            />

            <SelectField
                key={'my-drp'}
                placeholder={props.selectedCnr ?
                    createPlaceholderRenderer(props.userModelyears.length > 0, "MODELYEAR") : props.t("SELECT_CNR_FIRST")}
                clearable={true}
                searchable={true}
                disabled={!props.selectedCnr || props.userModelyears.length === 0}
                value={props.selectedModelyear}
                dataSource={props.userModelyears}
                rendererKey={(modelyear: ModelyearDto): string => ColumnFactory.mj2str(modelyear)}
                onChange={props.handleModelyearChange}
            />

            <SelectField
                key={'tf-drp'}
                placeholder={props.selectedModelyear ?
                    createPlaceholderRenderer(props.userTypefamilies.length > 0, "TYPEFAMILY") : props.t("SELECT_MY_FIRST")}
                clearable={true}
                searchable={true}
                disabled={!props.selectedModelyear || props.userTypefamilies.length === 0}
                value={props.selectedTypefamily}
                dataSource={props.userTypefamilies}
                rendererKey={(typefamily: TypefamilyDto): string => props.t("GLOBAL:" + typefamily.key)}
                onChange={props.handleTypefamilyChange}
            />

            <SelectField
                key={'der-drp'}
                placeholder={!props.selectedTypefamily ? props.t("SELECT_TF_FIRST")
                    : props.derivates.length === 0 ? props.t("EMPTY_LIST") : props.t("BTYP")}
                clearable={true}
                searchable={true}
                disabled={!props.selectedTypefamily || props.derivates.length === 0}
                value={props.selectedDerivate}
                dataSource={props.derivates}
                rendererKey={(value: OptionValue) => DerivateUtils.renderKeyDerivate(value as ModeltypeBasicDto, props.userLanguage)}
                boldFeatureTechData={true}
                onChange={props.handleDerivateChange}
            />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/views/TechnicalDataView/TechnicalDataHeader.tsx